<script>
    //import Conexoes from "../Classes/Conexoes";
    //import Constantes from "../Classes/Constantes";
    import { ItemInserir, Tipo } from "../../Classes/ItemInserir";
   import { Paper } from "@svelteuidev/core";
    import { DadosLogin , permissaoUsuario} from "../../Classes/Stores";
   
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import Constantes from "../../Classes/Constantes";
    import Conexoes from "../../Classes/Conexoes";
    import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";
    export let showModal = true;
    let msgConfirmacao;
    let token;
    const apiConsultaEdicao = Constantes.api_consultar_padrao;

    const query_code_carregar_edicao =
        Constantes.query_code_consulta_cadastro_usuario;
    const apiEdicao = Constantes.api_editar_padrao;
    const tabela = "usuarios";
    const itens = [
        new ItemInserir({
            rotulo: "Nome",
            nomeColuna: "nome_usuario",
            tamanho: 200,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Email",
            nomeColuna: "email",
            tamanho: 100,
            tipo: Tipo.EMAIL,
            obrigatorio: true,
            readonly: true,
        }),
        new ItemInserir({
            rotulo: "CPF",
            nomeColuna: "cpf",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
            readonly: true,
        }),

        new ItemInserir({
            rotulo: "Data de nascimento",
            nomeColuna: "data_nascimento",
            tamanho: 10,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Telefone (apenas DDD e número)",
            nomeColuna: "telefone",
            tamanho: 11,
            tipo: Tipo.TELEFONE,
            obrigatorio: true,
        }),

        new ItemInserir({
            rotulo: "Gênero",
            nomeColuna: "genero",
            tamanho: 30,
            tipo: Tipo.SELECAO,
            config_drop_down: {
                nome_coluna_saida: "genero",
                filtravel: true,
                itens: ["Masculino", "Feminino", "Outro"],
            },
        }),
    ];

    function Sucesso() {
        showModal = false;
        // //console.log("dispac",e)
        //if(e.detail==true){
        //
        // }
    }

    function Reenviar() {}
    function NaoConfirmado() {
        msgConfirmacao =
            "Token inválido, digite novamente ou clique em reenviar código";
    }
    function ChamarConfirmacao() {
        //console.log("chamando confirmacao")
        showModal = false;
        msgConfirmacao =
            "Um sms foi enviado ao seu telefone com um token. Digita o token para confirmar dados!";
    }

    let conexao = new Conexoes();
    let resultado;
    let api = "consultas.php";
    let parametros;
    let carregando = false;
    async function ConfirmaToken() {
        carregando = true;
        resultado = new Conexoes(api, {
            query_code: "confirma_token",
            token: token,
        });
        carregando = false;

        let confirmou = false;
        if (resultado) {
            if (resultado[0]) {
                if (resultado[0].id) {
                    confirmou = true;
                }
            }
        }
        if (confirmou) {
            Sucesso();
        } else {
            NaoConfirmado();
        }
    }
</script>

<Paper>
{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_ver_meu_cadastro)}
<br>
<br>
<br>
<br>

<AlteraDadosBasico
    id={$DadosLogin.id_usuario}
    {apiEdicao}
    botaoDeletar={"Excluir meu cadastro"}
    botaoAlterar={"Alterar meu cadastro"}
    {apiConsultaEdicao}
    {itens}
    {query_code_carregar_edicao}
    {tabela}
/>
{:else}

<br>
<br>
<br>
<br>

<TelasAcessoNaoAutorizado />

{/if}

</Paper>
<style>
    .modal {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .modal-content {
        background-color: #fefefe;
        padding: 20px;
        border: 1px solid #888;
        width: 80%;
        border-radius: 10px;
        max-height: 80%;
        overflow-y: auto;
    }

    .modal-body {
        max-height: calc(100% - 40px); /* Ajuste para o padding */
        overflow-y: auto;
    }

    .close {
        color: #aaa;
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 20px;
        font-weight: bold;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }

    .close:hover {
        color: #000;
    }
</style>
